export default __webpack_public_path__ + "static/media/18bogeys.3d5b5c11.png";